import React from "react";
import { 
    Package, 
    Store, 
    Truck, 
    TrendingUp, 
    Clock3, 
    Wallet, 
    CheckCircle2,
    Star,
    Box
} from "lucide-react";

const SellerAuthVisualHero = ({ activeStep = 1 }) => {
    return (
        <div className="nz-auth-visual-side">
            {/* Dynamic premium glowing graphic accents */}
            <div className="nz-auth-glow-accent-1"></div>
            <div className="nz-auth-glow-accent-2"></div>
            
            {/* 📦 Floating Mockup Cards (SaaS-styled seller visualizers) */}
            <div className="nz-mockup-cluster-container">
                
                {/* 🛒 Card 1: Recent Orders */}
                <div className="nz-mock-card nz-mock-card-order-today premium-card">
                    <div className="nz-mock-card-header">
                        <span className="nz-mock-card-tag">
                            <Package size={10} className="nz-icon-inline" />
                            Live Orders
                        </span>
                        <span className="nz-mock-card-val-delivered">
                            <div className="nz-pulse-dot" style={{ width: '4px', height: '4px', marginRight: '4px' }}></div>
                            Updating
                        </span>
                    </div>
                    
                    <div className="nz-mock-product-row">
                        <div className="nz-seller-avatar bg-amber-100" style={{ width: 20, height: 20, borderRadius: 4 }}>
                            <Clock3 size={10} className="text-amber-600" />
                        </div>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">Order #1042</div>
                            <div className="nz-mock-product-meta">Pending • 3 items</div>
                        </div>
                        <div className="nz-mock-qty-badge" style={{ color: '#d97706', background: '#fef3c7' }}>₹450</div>
                    </div>
                    
                    <div className="nz-mock-product-row">
                        <div className="nz-seller-avatar bg-blue-100" style={{ width: 20, height: 20, borderRadius: 4 }}>
                            <Truck size={10} className="text-blue-600" />
                        </div>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">Order #1041</div>
                            <div className="nz-mock-product-meta">Dispatched • 1 item</div>
                        </div>
                        <div className="nz-mock-qty-badge" style={{ color: '#0284c7', background: '#e0f2fe' }}>₹120</div>
                    </div>

                    <div className="nz-mock-product-row">
                        <div className="nz-seller-avatar bg-emerald-100" style={{ width: 20, height: 20, borderRadius: 4 }}>
                            <CheckCircle2 size={10} className="text-emerald-600" />
                        </div>
                        <div className="nz-mock-product-info">
                            <div className="nz-mock-product-name">Order #1040</div>
                            <div className="nz-mock-product-meta">Delivered • 5 items</div>
                        </div>
                        <div className="nz-mock-qty-badge" style={{ color: '#059669', background: '#d1fae5' }}>₹890</div>
                    </div>
                </div>

                {/* 💰 Card 2: Total Earnings */}
                <div className="nz-mock-card nz-mock-card-savings premium-card-orange">
                    <div className="nz-mock-card-header">
                        <span className="nz-mock-card-tag-white">
                            <Wallet size={10} className="nz-icon-inline-white" />
                            Total Earnings
                        </span>
                        <TrendingUp size={12} className="nz-icon-inline-white-opacity" />
                    </div>
                    
                    <div className="nz-mock-savings-amount">
                        ₹84,500 <span className="nz-mock-savings-period">this month</span>
                    </div>
                    
                    <div className="nz-mock-savings-insight">
                        <TrendingUp size={9} className="nz-icon-inline-orange" />
                        +15% vs Last Month
                    </div>

                    {/* Micro interactive bar chart */}
                    <div className="nz-mock-savings-bars">
                        <div className="nz-savings-bar" style={{ height: "45%" }}></div>
                        <div className="nz-savings-bar" style={{ height: "65%" }}></div>
                        <div className="nz-savings-bar" style={{ height: "80%" }}></div>
                        <div className="nz-savings-bar active" style={{ height: "100%" }}>
                            <div className="nz-bar-pulse"></div>
                        </div>
                        <div className="nz-savings-bar" style={{ height: "70%" }}></div>
                    </div>
                    
                    <div className="nz-mock-savings-footer">
                        <Clock3 size={8} className="nz-icon-inline-white-opacity-more" />
                        Updated just now
                    </div>
                </div>

                {/* 🏪 Card 3: Shop Overview */}
                <div className="nz-mock-card nz-mock-card-found-shops premium-card">
                    <div className="nz-mock-card-header">
                        <span className="nz-mock-card-tag-blue">
                            <Store size={10} className="nz-icon-inline-blue" />
                            Shop Overview
                        </span>
                        <div className="nz-live-badge">
                            <span className="nz-pulse-dot"></span>
                            Online
                        </div>
                    </div>
                    
                    <div className="nz-mock-seller-title">Performance Metrics</div>
                    
                    <div className="nz-mock-seller-list">
                        <div className="nz-mock-seller-row">
                            <div className="nz-seller-avatar bg-amber-100">
                                <Star size={10} className="text-amber-500" style={{ fill: '#f59e0b' }} />
                            </div>
                            <div className="nz-seller-info">
                                <div className="nz-seller-name">Shop Rating</div>
                                <div className="nz-seller-meta">4.8 ⭐ • 124 Reviews</div>
                            </div>
                        </div>
                        <div className="nz-mock-seller-row">
                            <div className="nz-seller-avatar bg-indigo-100">
                                <Box size={10} className="text-indigo-600" />
                            </div>
                            <div className="nz-seller-info">
                                <div className="nz-seller-name">Active Inventory</div>
                                <div className="nz-seller-meta">145 Products Listed</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* 📣 Premium Copy Slogan and Navigation Paginations */}
            <div className="nz-visual-slogan-section">
                <div className="nz-logo-badge mb-4">
                    <Store size={12} className="nz-icon-inline-orange" />
                    <span>Nearzon Seller Partner</span>
                </div>
                
                <h1 className="nz-visual-slogan-title">Grow Your Business.<br />Reach More Customers.</h1>
                
                <p className="nz-visual-slogan-desc">
                    Manage orders, track earnings, and scale your local shop with Nearzon's powerful seller tools.
                </p>
                
                <div className="nz-visual-paginator">
                    <div className={`nz-paginator-dot ${activeStep === 1 ? "active" : ""}`}></div>
                    <div className={`nz-paginator-dot ${activeStep === 2 ? "active" : ""}`}></div>
                    <div className={`nz-paginator-dot ${activeStep === 3 ? "active" : ""}`}></div>
                </div>
            </div>
        </div>
    );
};

export default SellerAuthVisualHero;
